import React, { useEffect, useRef, useState } from "react";

export default function AnimatedNumber({ value = 0, duration = 1000, className = "", suffix = "", ...rest }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef();

  useEffect(() => {
    const start = performance.now();
    const from = 0;
    const to = Number(value) || 0;
    const step = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) ref.current = requestAnimationFrame(step);
    };
    ref.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(ref.current);
  }, [value, duration]);

  const formatted = Math.round(display).toLocaleString("fr-FR");
  return <span className={className} {...rest}>{formatted}{suffix}</span>;
}
